module.exports = __webpack_public_path__ + "img/favicon-dark.037a543d.png";